import { ROUTES } from "@/common/constants/routes";
import { TUserData } from "@/common/types/user";
import { isSafeInternalRedirect } from "@/common/utils/safe-redirect";

/**
 * Auto-created (Google/magic-link) users can be active with no club yet,
 * which the plain club-role redirect doesn't account for — send them to
 * onboarding to create their club (mandatory; enforced in middleware.ts).
 */
export function resolvePostLoginRoute(user: TUserData): string {
  if (user.account_type === "player") {
    return ROUTES.PLAYER.DASHBOARD;
  }

  if (user.global_role === "admin") {
    return ROUTES.DASHBOARD;
  }

  if (user.club_id) {
    return ROUTES.CLUB.DASHBOARD;
  }

  return ROUTES.ONBOARDING;
}

/**
 * P4-4 deep-link return-after-auth: picks where to `navigate()` a user right
 * after a successful login/magic-link verify, honoring an in-flight
 * `?redirect=` param when — and only when — it's a safe internal path.
 *
 * `redirect` is purely a navigation hint. It never grants access by itself:
 * the destination route's own guard (`src/middleware.ts`) still runs after
 * the navigate and still decides whether this now-authenticated user is
 * allowed to see that page (e.g. an uninvited user following a valid magic
 * link to another club's event still hits that page's own 404/guard).
 */
export function resolvePostAuthRedirect(
  user: TUserData,
  redirect: string | null | undefined
): string {
  if (redirect && isSafeInternalRedirect(redirect)) {
    return redirect;
  }

  return resolvePostLoginRoute(user);
}
